import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=23a14369&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../../less/personalInfo.less?vue&type=style&index=0&id=23a14369&lang=less&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=23a14369&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a14369",
  null
  
)

export default component.exports